import React from "react";
import { PrivateNoticesUIProvider } from "./PrivateNoticesUIContext";
import { PrivateNoticesCard } from "./PrivateNoticesCard";

export function PrivateNoticesPage({ history }) {
  const privateNoticesUIEvents = {
    openNewPrivateNoticePage: () => {
      history.push("/ozel-duyurular/ekle");
    },
    openPrivateNoticeDetailPage: (id) => {
      history.push(`/ozel-duyurular/detay/${id}`);
    },
  };
  
  return (
    <PrivateNoticesUIProvider privateNoticesUIEvents={privateNoticesUIEvents}>
      <PrivateNoticesCard />
    </PrivateNoticesUIProvider>
 );
}